import { render, staticRenderFns } from "./TimeslotSelector.vue?vue&type=template&id=b6438d90"
import script from "./TimeslotSelector.vue?vue&type=script&lang=js"
export * from "./TimeslotSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports